import type { ModeOfTransport } from '@zen/graphql/types.generated';

export const NOT_YET_KNOWN = 'NOT_YET_KNOWN' as const;

export type NotYetKnown = typeof NOT_YET_KNOWN;

export type ModeOfTransportValue = ModeOfTransport | NotYetKnown;
